import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AutorizacionConsultarComponent } from "./components/autorizacion-consultar/autorizacion-consultar.component";
import { SharedModule } from "@siu/shared";
import { SigoVehiculoModule } from "../vehiculos-sigo/sigo-vehiculo.module";
import { AutorizacionConsultarStore } from "./store/autorizacion.consultar.store";

@NgModule({
  declarations: [AutorizacionConsultarComponent],
  imports: [CommonModule, SharedModule, SigoVehiculoModule],
  exports: [AutorizacionConsultarComponent],
  providers: [AutorizacionConsultarStore],
  entryComponents: [AutorizacionConsultarComponent],
})
export class AutorizacionesModule {}
